import * as React from "react";
import { GatsbyImage } from "gatsby-plugin-image";
import { BLOCKS, INLINES } from "@contentful/rich-text-types";
import { renderRichText } from "gatsby-source-contentful/rich-text";

const renderOptions = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (node, children) => {
      const [{ value }] = node.content;

      if (value !== "" || node.content.length > 1) {
        return <p>{children}</p>;
      }

      return null;
    },

    [INLINES.HYPERLINK]: (node, children) => (
      <Link href={node.data.uri}>{children}</Link>
    ),
  },
};

const Concept = ({ title, description, pictos }) => {
  return (
    <section className="concept">
      <div className="container">
        <div>
          <header>
            <h2 className="heading heading-large">{title}</h2>
            {renderRichText(description, renderOptions)}
          </header>
          <div className="concept-content">
            {pictos.map((picto, index) => (
              <div key={index} className="concept-picto">
                {picto.image && (
                  <GatsbyImage
                    image={picto.image.gatsbyImageData}
                    alt={picto.image.description}
                    className="concept-picto-image"
                  />
                )}
                {picto.text && (
                  <div className="concept-picto-text">
                    {renderRichText(picto.text, renderOptions)}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Concept;
